import { Box, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  [theme.breakpoints.down('lg')]: {
    gap: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const StyledBillingTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[300],
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  color: theme.palette.grey[300],
}));
